import { render, staticRenderFns } from "./SmartImportTable.vue?vue&type=template&id=5731fe22&scoped=true"
import script from "./SmartImportTable.vue?vue&type=script&lang=js"
export * from "./SmartImportTable.vue?vue&type=script&lang=js"
import style0 from "./SmartImportTable.vue?vue&type=style&index=0&id=5731fe22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5731fe22",
  null
  
)

export default component.exports